"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsList.title': '通信代理',
    'whatsapp.settingsList.add': '添加电话号码',
    'whatsapp.settingsList.empty': '未配置电话号码。添加一个以开始使用。',
    'whatsapp.settingsList.language': '语言',
    'whatsapp.settingsList.avatar': '头像',
    'whatsapp.settingsList.actions': '操作',
    'whatsapp.settingsList.loadFailed': '无法加载WhatsApp配置。',
    'whatsapp.settingsList.deleteConfirm': '您确定要删除此WhatsApp配置吗？',
    'whatsapp.settingsList.deleted': 'WhatsApp配置已删除。',
    'whatsapp.settingsList.deleteFailed': '无法删除WhatsApp配置。',
};
